import script from "./FamiliareSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamiliareSection.vue?vue&type=script&setup=true&lang=ts"

import "./FamiliareSection.vue?vue&type=style&index=0&id=3cfd353e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cfd353e"]])

export default __exports__